<script>

import NavBar from './NavBar.vue';
import LeftNavMenu from './LeftNavMenu.vue';
import GroupsComponent from './GroupsComponent.vue';

    export default {
    name: 'GroupsPage',
    props: { titolo: String },
    //components: { NavBar, LeftNavMenu,LoginComponent }
    components: { NavBar, LeftNavMenu, GroupsComponent }
}
</script>

<template lang="html">

        <body>
            <NavBar />
           <LeftNavMenu />
            <GroupsComponent />
        </body>   
   
</template>
  
<style lang="css">

</style>